import { render, staticRenderFns } from "./OxygenGas.vue?vue&type=template&id=58482315&"
import script from "./OxygenGas.vue?vue&type=script&lang=js&"
export * from "./OxygenGas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports